module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/5f30f776d217f3ed6100de1c3b05cb16.png";